import axios from 'axios'

const rlsvoteApi = axios.create({
  baseURL: '/api/rlsvote',
  headers: { 'Content-Type': 'application/json' },
})

export default rlsvoteApi
